import React from "react";
import "./App.css";
import Main from "./container";

const App = () => {
  return <Main />;
};

export default App;
